<style src="./ConsumerMessage.scss" lang="scss"></style>
<template>
  <section class="wrapper wrapper-content animated fadeIn monitor-message">
    <section class="row">
      <section class="col-lg-4 users">
        <user-list />
      </section>
      <section class="col-lg-8 messagearea">
        <chat-message :messages="messages" me="web" to="consumer" />
      </section>
    </section>
  </section>
</template>

<script>
import UserList from './components/user-list/UserList';
import ChatMessage from '@/components/chat-message/ChatMessage';
import socket from '@/store/socket';
import { MESSAGES_EVENTS } from '@/config/config';
import { mapGetters } from 'vuex';

export default {
  components: {
    UserList,
    ChatMessage,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      messages: 'MESSAGES/consumerMessages',
    }),
  },
  destroyed() {
    socket.off(MESSAGES_EVENTS.CONSUMER_PRIVATE_MESSAGE);
  },
};
</script>
